/* eslint-disable react/jsx-props-no-spreading */
const StepTwoIcon = (props) => (
	<svg width={128} height={120} viewBox="0 0 128 120" {...props}>
		<g fill="none" fillRule="evenodd">
			<circle cx="60" cy="60" r="60" fill="#FFF" opacity=".327" />
			<path
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
				d="M73 33.5H47c-.69 0-1.315.28-1.768.732-.452.453-.732 1.078-.732 1.768v48c0 .69.28 1.315.732 1.768.453.452 1.078.732 1.768.732h26c.69 0 1.315-.28 1.768-.732.452-.453.732-1.078.732-1.768V36c0-.69-.28-1.315-.732-1.768-.453-.452-1.078-.732-1.768-.732z"
			/>
			<path
				fill="#FFF"
				stroke="#4D3951"
				strokeWidth="3"
				d="M67.5 33.5h-15V36c0 .69.28 1.315.732 1.768.453.452 1.078.732 1.768.732h10c.69 0 1.315-.28 1.768-.732.452-.453.732-1.078.732-1.768v-2.5z"
			/>
			<g stroke="#4D3951" strokeWidth="3" transform="rotate(-45 112.098 -33.255)">
				<circle cx="12.5" cy="12.5" r="10.5" fill="#7CDBB7" />
				<path fill="#FFF" d="M12.5 23.814H13.5V30.814H12.5z" />
			</g>
			<g stroke="#4D3951" strokeWidth="2">
				<path
					d="M10.328 16.278c4.296-4.296 4.296-11.26 0-15.556M5.5 13.45c2.734-2.734 2.734-7.166 0-9.9"
					transform="translate(76 35)"
				/>
			</g>
			<g stroke="#4D3951" strokeWidth="2">
				<path
					d="M10.328 16.278c4.296-4.296 4.296-11.26 0-15.556M5.5 13.45c2.734-2.734 2.734-7.166 0-9.9"
					transform="matrix(-1 0 0 1 44 35)"
				/>
			</g>
			<g transform="translate(88)">
				<circle cx="20" cy="20" r="20" fill="#FFF" />
				<text
					fill="#373737"
					fontFamily="Inter"
					fontSize="24"
					fontWeight="700"
				>
					<tspan x="13.64" y="28">
						2
					</tspan>
				</text>
			</g>
		</g>
	</svg>
);

export default StepTwoIcon;
